module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.cdd2566d.webp";